import React, { useState } from "react";
import { CaretDownFilled } from "@ant-design/icons";

import BookmarkIcon from "components/actions/Bookmark";
import Button from "components/ui/button/Button";
import Tooltip from "components/ui/tooltip/Tooltip";
import { useSavedSuppliers } from "lib/hooks/api/signals/useSavedSuppliers";
import { SuppliersModal } from "./SuppliersModal";

import css from "./SaveSupplier.module.scss";

type Props = {
  supplierGuids: string[];
};

function BulkSaveNoticeSupplier({ supplierGuids }: Props) {
  const [open, setOpen] = useState(false);

  // Just need loading state for the button. Should wait until the saved suppliers API is ready
  const { isLoading } = useSavedSuppliers();

  const onOpenChange = (open: boolean) => {
    setOpen(open);
  };

  return (
    <div>
      <SuppliersModal open={open} onOpenChange={onOpenChange} guids={supplierGuids} />
      <Tooltip content={`Save ${supplierGuids.length} suppliers as a competitor or partner`}>
        <Button
          buttonType="secondary"
          className={css.bookmarkButton}
          loading={isLoading}
          onClick={() => onOpenChange(true)}
        >
          <BookmarkIcon colour="blue" />
          <CaretDownFilled className={css.caretDown} />
        </Button>
      </Tooltip>
    </div>
  );
}

export default BulkSaveNoticeSupplier;
